module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/izabela-wadas-bad761bf67e7e565f3479c89c497b564.png";